import Parameter from "./Parameter";
import PortalDocument from "../../document/PortalDocument";
import {Parameter as ParameterType} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

export default class DefaultParameters<T_PARAMETER_TYPE extends ParameterType> {
	private readonly parameters: Array<Parameter<T_PARAMETER_TYPE>>;

	constructor(parameters?: Array<Parameter<T_PARAMETER_TYPE>>) {
		this.parameters = FunctionHelper.applyValue(parameters, []);
	}

	add(parameter: Parameter<T_PARAMETER_TYPE>): void {
		this.parameters.push(parameter);
	}

	get(documents: Array<PortalDocument>): Parameter<T_PARAMETER_TYPE> | undefined {
		for (let parameter of this.parameters.values()) {
			if (parameter.isSupported(documents)) {
				return parameter;
			}
		}
	}
}